import axios from 'axios';
import { partial } from 'lodash';

export default {
  info: partial(log, 'info'),
  warn: partial(log, 'warn'),
  error: partial(log, 'error'),
  debug: partial(log, 'debug')
};

const LOG_ENDPOINT = '/log/';

function log(level, message, full_message, metadata) {
  axios.post(LOG_ENDPOINT + level, {
    message,
    full_message,
    metadata
  });
}



// WEBPACK FOOTER //
// ./src/services/log/LogService.js